
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree935"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree935"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $7305d439e40467ae$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["3bR9d","person.03be92ed.js","lxIAu","sprites.330033bd.jpg"]'));

var $a4b8f2f5b9e34a66$exports = {};
var $b10e08554b98a0eb$export$8d01c972ee8b14a9 = /** @class */ function() {
    function Canvas() {
        this.canvasElement = document.getElementById("canvas");
        this.canvasContext = this.canvasElement.getContext("2d");
        this.x = 0;
        this.y = 0;
        this.width = 500;
        this.height = 500;
    }
    return Canvas;
}();


var $75e6993b41704ec1$export$6a77e7ef76b918fb = /** @class */ function() {
    function KeyBoardHandler() {
        var _this = this;
        this.keyboardState = {
            top: false,
            left: false,
            bottom: false,
            right: false
        };
        var moves = {
            w: function(newValue) {
                _this.keyboardState.top = newValue;
            },
            s: function(newValue) {
                _this.keyboardState.bottom = newValue;
            },
            a: function(newValue) {
                _this.keyboardState.left = newValue;
            },
            d: function(newValue) {
                _this.keyboardState.right = newValue;
            }
        };
        window.addEventListener("keydown", function(event) {
            var _a;
            (_a = moves[event.key]) === null || _a === void 0 || _a.call(moves, true);
        });
        window.addEventListener("keyup", function(event) {
            var _a;
            (_a = moves[event.key]) === null || _a === void 0 || _a.call(moves, false);
        });
    }
    return KeyBoardHandler;
}();


var $c72682d2f9f6bbaf$exports = {};

$parcel$export($c72682d2f9f6bbaf$exports, "Person", () => $c72682d2f9f6bbaf$export$d0e824889e01c751);
var $3354f5134e2bcbed$exports = {};
$3354f5134e2bcbed$exports = new URL("sprites.330033bd.jpg", import.meta.url).toString();


var $c72682d2f9f6bbaf$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c72682d2f9f6bbaf$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c72682d2f9f6bbaf$var$timeInMsToUpdateSprite = 150;
var $c72682d2f9f6bbaf$var$spriteActive = 0;
setInterval(function() {
    $c72682d2f9f6bbaf$var$spriteActive += 1;
    if ($c72682d2f9f6bbaf$var$spriteActive >= 4) $c72682d2f9f6bbaf$var$spriteActive = 0;
}, $c72682d2f9f6bbaf$var$timeInMsToUpdateSprite);
var $c72682d2f9f6bbaf$var$directionColWalkSprite = {
    Bottom: 0,
    Left: 1,
    Right: 2,
    Top: 3
};
var $c72682d2f9f6bbaf$export$d0e824889e01c751 = /** @class */ function() {
    function Person(canvas, keyboardState) {
        this.antiTankSprite = undefined;
        this.canvas = canvas;
        this.keyboardState = keyboardState;
        this.speed = 3;
        this.stoppedSprite = 0;
        this.drawPosX = 150;
        this.drawPosY = 150;
        this.totalSpriteRows = 4;
        this.totalSpriteCols = 4;
        this.drawWidth = 100;
        this.drawHeight = 100;
        this.spriteStartCol = $c72682d2f9f6bbaf$var$directionColWalkSprite.Top;
    }
    Person.prototype.loadFiles = function() {
        return $c72682d2f9f6bbaf$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $c72682d2f9f6bbaf$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var antiTankSprite = new Image();
                        antiTankSprite.src = (0, (/*@__PURE__*/$parcel$interopDefault($3354f5134e2bcbed$exports)));
                        antiTankSprite.onload = function() {
                            _this.antiTankSprite = antiTankSprite;
                            resolve(antiTankSprite);
                        };
                        antiTankSprite.onerror = function(error) {
                            reject(error);
                        };
                    })
                ];
            });
        });
    };
    Person.prototype.handleWalking = function() {
        if (this.keyboardState.right) this.drawPosX += this.speed;
        else if (this.keyboardState.left) this.drawPosX += this.speed * -1;
        if (this.keyboardState.top) this.drawPosY += this.speed * -1;
        else if (this.keyboardState.bottom) this.drawPosY += this.speed;
        var exceedsLeftBoundary = this.drawPosX <= 0;
        var exceedsRightBoundary = this.drawPosX + this.drawWidth >= this.canvas.width;
        if (exceedsLeftBoundary) this.drawPosX = 0;
        else if (exceedsRightBoundary) this.drawPosX = this.canvas.width - this.drawWidth;
        var exceedsTopBoundary = this.drawPosY <= 0;
        var exceedsBottomBoundary = this.drawPosY + this.drawHeight >= this.canvas.height;
        if (exceedsTopBoundary) this.drawPosY = 0;
        else if (exceedsBottomBoundary) this.drawPosY = this.canvas.height - this.drawHeight;
    };
    Person.prototype.render = function() {
        if (this.keyboardState.top) this.spriteStartCol = $c72682d2f9f6bbaf$var$directionColWalkSprite.Top;
        if (this.keyboardState.bottom) this.spriteStartCol = $c72682d2f9f6bbaf$var$directionColWalkSprite.Bottom;
        if (this.keyboardState.left) this.spriteStartCol = $c72682d2f9f6bbaf$var$directionColWalkSprite.Left;
        if (this.keyboardState.right) this.spriteStartCol = $c72682d2f9f6bbaf$var$directionColWalkSprite.Right;
        var playerIsStopped = !this.keyboardState.bottom && !this.keyboardState.left && !this.keyboardState.right && !this.keyboardState.top;
        var spriteStartRow = playerIsStopped ? this.stoppedSprite : $c72682d2f9f6bbaf$var$spriteActive;
        var spriteWidth = this.antiTankSprite.width / this.totalSpriteRows;
        var spriteHeight = this.antiTankSprite.height / this.totalSpriteCols;
        var startSprite = spriteStartRow * spriteWidth;
        var endSprite = this.spriteStartCol * spriteHeight;
        this.handleWalking();
        this.canvas.canvasContext.drawImage(this.antiTankSprite, startSprite, endSprite, spriteWidth, spriteHeight, this.drawPosX, this.drawPosY, this.drawWidth, this.drawHeight);
    };
    return Person;
}();


var $a4b8f2f5b9e34a66$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a4b8f2f5b9e34a66$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
(function() {
    return $a4b8f2f5b9e34a66$var$__awaiter(this, void 0, void 0, function() {
        var canvas, keyboard, person, draw;
        return $a4b8f2f5b9e34a66$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    canvas = new (0, $b10e08554b98a0eb$export$8d01c972ee8b14a9)();
                    keyboard = new (0, $75e6993b41704ec1$export$6a77e7ef76b918fb)();
                    person = new (0, $c72682d2f9f6bbaf$exports.Person)(canvas, keyboard.keyboardState);
                    return [
                        4 /*yield*/ ,
                        person.loadFiles()
                    ];
                case 1:
                    _a.sent();
                    draw = function() {
                        canvas.canvasContext.clearRect(canvas.x, canvas.y, canvas.width, canvas.height);
                        person.render();
                        requestAnimationFrame(draw);
                    };
                    draw();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
})();


//# sourceMappingURL=person.03be92ed.js.map
